<kendo-tabstrip [tabPosition]="position" (tabSelect)="onTabSelected($event)" class="k-tabstrip">
  <kendo-tabstrip-tab [title]="'Architecture Details'" [selected]="true">
    <ng-template kendoTabContent>
      <section>
        <kendo-grid [data]="architectureDetailsGridView"
                    [height]="470"
                    [sortable]="true"
                    [navigable]="true"
                    [filterable]="true"
                    [groupable]="false"
                    [reorderable]="true"
                    [resizable]="false"
                    [sort]="architectureDetailsGridstate.sort"
                    (sortChange)="architectureDetailsGridSortChange($event)"
                    [pageable]="{ buttonCount: 5, info: true }"
                    [pageSize]="architectureDetailsGridstate.take"
                    [skip]="architectureDetailsGridstate.skip"
                    [columnMenu]="false"
                    (pageChange)="architectureDetailsGridPageChange($event)"
                    (dataStateChange)="architectureDetailsDataStateChange($event)"
                    [filter]="architectureDetailsGridstate.filter"
                    [loading]="architectureDetailsLoading">

          <kendo-grid-column field="categoryDescription" title="{{architectureDetails.categoryLbl}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="subCategoryDescription" title="{{architectureDetails.subCategoryLbl}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="urlPath" title="{{architectureDetails.urlLbl}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-command-column title="{{architectureDetails.isActiveLbl}}" [width]="135" field="isActive">
            <ng-template kendoGridCellTemplate let-dataItem>
              <kendo-switch [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'"
                            [offLabel]="'No'" [disabled]="true">
              </kendo-switch>
            </ng-template>
          </kendo-grid-command-column>

          <kendo-grid-command-column title="{{architectureDetails.actionLbl}}" [width]="150" field="">
            <ng-template kendoGridCellTemplate let-dataItem>
              <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                      (click)="editArchitectureDetails(dataItem)">
                <span class=" k-icon k-i-edit k-i-pencil"></span>
              </button>

              <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem,'SubCategory')">
                <span class="k-icon k-i-trash">
                </span>
              </button>

            </ng-template>
          </kendo-grid-command-column>

          <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
            <kendo-pager-info></kendo-pager-info>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
          </ng-template>
        </kendo-grid>
        <div class="col-sm-12 center">
          <button (click)="toggleArchitectureCategoryDialog()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
            Add New Category
          </button>&nbsp;
          <button (click)="toggleArchitectureDetailsDialog()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
            Add New Sub Category
          </button>
        </div>
      </section>
      <section class="dialogSection">
        <kendo-dialog title="Add Category" *ngIf="architectureCategoryDialog.opened" (close)="toggleArchitectureCategoryDialog()">
          <form [formGroup]="architectureCategoryForm">
            <div class="row">
              <input type="hidden" formControlName="categoryId" />
              <div class="col-sm-12">
                <div class="form-group">
                  <label class="lblCls">
                    {{architectureCategory.categoryLbl}}<span class="requiredField">*</span>
                  </label>
                  <input type="text" kendoTextBox formControlName="categoryDescription" class="kendoInput" [ngClass]="{'borderRed':architectureCategory.isEmptyCategoryDescription && architectureCategory.isSubmitted}" (blur)="validateArchitectureCategoryForm()" />
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{architectureCategory.isCategoryActiveLbl}}
                  </label>
                  <kendo-switch formControlName="isCategoryActive" [onLabel]="'Yes'" [offLabel]="'No'"
                                class="activeSwitchCls">
                  </kendo-switch>
                </div>
              </div>

            </div>

            <div class="dialog-btn-section">
              <div class="row">
                <div class="col-sm-12 float-left">
                  <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 btn-align-center">
                  <div class="btn-group" role="group">
                    <button kendoButton [disabled]="categorySaveInProcess" class=" m-3 btn k-button dialogBtnSize"
                            (click)="toggleArchitectureCategoryDialog()">
                      Close
                    </button> &nbsp;&nbsp;
                    <button kendoButton [disabled]="categorySaveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                            (click)="saveArchitectureCategory()">
                      Save<kendo-loader *ngIf="categorySaveInProcess" style="color:blue"></kendo-loader>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </kendo-dialog>
      </section>
      <section class="dialogSection">
        <kendo-dialog title="Add Sub Category" *ngIf="architectureDetailsDialog.opened" (close)="toggleArchitectureDetailsDialog()">
          <form [formGroup]="architectureDetailsForm">

            <div class="row">
              <input type="hidden" formControlName="subCategoryId" />
              <div class="col-sm-12">
                <div class="form-group">
                  <label class="lblCls">
                    {{architectureDetails.categoryLbl}}<span class="requiredField">*</span>
                  </label>
                  <kendo-dropdownlist class="kendoInput" formControlName="category" [ngModel]="{categoryDescription:selectedCategory,categoryId:selectedCategoryId}" [data]="categoryData"
                                      textField="categoryDescription" valueField="categoryId" [ngClass]="{'borderRed':architectureDetails.isEmptyCategory && architectureDetails.isSubmitted}" (blur)="validateArchitectureDetailsForm()">
                  </kendo-dropdownlist>
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{architectureDetails.subCategoryLbl}}<span class="requiredField">*</span>
                  </label>
                  <input type="text" kendoTextBox formControlName="subCategory" class="kendoInput" [ngClass]="{'borderRed':architectureDetails.isEmptySubCategory && architectureDetails.isSubmitted}" (blur)="validateArchitectureDetailsForm()" />
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{architectureDetails.uploadLbl}}
                    <!--<span class="requiredField">*</span>-->
                  </label>
                  <!--<input type="file" formControlName="fileUpload" class="k-button btn kendoInput" name="fileupload"
                  (change)="handleFileInput($event.target.files)" />-->
                  <div class="kendoInput">
                    <app-upload [multiple]="false" (fileSelect)="subCategoryImageSelected($event)" [uploadFolderPath]="'TempDocs'"
                                (uploadSuccess)="subCategoryUploadSuccess($event)" [fileRestrictions]="fileRestrictions"></app-upload>
                  </div>
                  <label class="lblCls">
                    {{filePath}}
                  </label>
                </div>
                <div class="form-group">
                  <label class="lblCls">
                    {{architectureDetails.isActiveLbl}}
                  </label>
                  <kendo-switch formControlName="isActive" [onLabel]="'Yes'" [offLabel]="'No'"
                                class="activeSwitchCls">
                  </kendo-switch>
                </div>
              </div>

            </div>

            <div class="dialog-btn-section">
              <div class="row">
                <div class="col-sm-12 float-left">
                  <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 btn-align-center">
                  <div class="btn-group" role="group">
                    <button kendoButton [disabled]="subCategorySaveInProcess" class=" m-3 btn k-button dialogBtnSize"
                            (click)="toggleArchitectureDetailsDialog()">
                      Close
                    </button> &nbsp;&nbsp;
                    <button kendoButton [disabled]="subCategorySaveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                            (click)="saveArchitectureSubCategory()">
                      Save<kendo-loader *ngIf="subCategorySaveInProcess" style="color:blue"></kendo-loader>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </kendo-dialog>
      </section>

    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab [title]="'Test Reports'">
    <ng-template kendoTabContent>
      <section>
        <kendo-grid [data]="testReportGridView"
                    [height]="470"
                    [sortable]="true"
                    [navigable]="true"
                    [filterable]="true"
                    [groupable]="false"
                    [reorderable]="true"
                    [resizable]="false"
                    [sort]="testReportGridstate.sort"
                    (sortChange)="testReportGridSortChange($event)"
                    [pageable]="{ buttonCount: 5, info: true }"
                    [pageSize]="testReportGridstate.take"
                    [skip]="testReportGridstate.skip"
                    [columnMenu]="false"
                    (pageChange)="testReportGridPageChange($event)"
                    (dataStateChange)="testReportDataStateChange($event)"
                    [filter]="testReportGridstate.filter"
                    [loading]="testReportLoading">

          <kendo-grid-column field="subCategoryDescription" title="{{testReportLbl.architectureSubCategory}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="testCategoryDescription" title="{{testReportLbl.testCategory}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="testSubCategoryDescription" title="{{testReportLbl.testSubCategory}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="testType" title="{{testReportLbl.testType}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="testReportDescription" title="{{testReportLbl.testDescription}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="testReportNumber" title="{{testReportLbl.reportNumber}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="ecNumber" title="{{testReportLbl.ecNumber}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="ecVersion" title="{{testReportLbl.ecVersion}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="urlPath" title="{{testReportLbl.url}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <!--<kendo-grid-command-column title="{{testReportLbl.isActive}}" [width]="135" field="isActive">
            <ng-template kendoGridCellTemplate let-dataItem>
              <kendo-switch (click)="switchChange(dataItem)" [(ngModel)]="dataItem.isActive" [onLabel]="'Yes'"
                            [offLabel]="'No'">
              </kendo-switch>
            </ng-template>
          </kendo-grid-command-column>-->

          <kendo-grid-command-column title="{{testReportLbl.action}}" [width]="150" field="">
            <ng-template kendoGridCellTemplate let-dataItem>
              <button kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls"
                      (click)="editTestReport(dataItem)">
                <span class=" k-icon k-i-edit k-i-pencil"></span>
              </button>

              <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem,'TestReport')">
                <span class="k-icon k-i-trash">
                </span>
              </button>

            </ng-template>
          </kendo-grid-command-column>

          <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
            <kendo-pager-info></kendo-pager-info>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
          </ng-template>
        </kendo-grid>
        <div class="col-sm-12 center">

          <button (click)="toggleTestCategoryDialog()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
            Add Test Category
          </button>
          <button (click)="toggleArchitectureSubCategoryDialog()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
            Add Test Sub Category
          </button>
          <button (click)="toggleTestReportDialog()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
            Add New Test
          </button>
        </div>
        <section class="dialogSection">
          <kendo-dialog title="Add Test Sub Category" *ngIf="architectureSubCategoryDialog.opened" (close)="toggleArchitectureSubCategoryDialog()">
            <form [formGroup]="architectureSubCategoryForm">
              <div class="row">
                <input type="hidden" formControlName="subCategoryId" />
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="lblCls">
                      {{architectureSubCategory.architectureSubCategoryLbl}}<span class="requiredField">*</span>
                    </label>
                    <kendo-dropdownlist class="kendoInput" formControlName="architectureSubCategory" [data]="architectureSubCategoryData"
                                        textField="subCategoryDescription" valueField="subCategoryId" (selectionChange)="architectureSubCategoryChange($event)" [ngModel]="{subCategoryDescription:selectedTestCategory,subCategoryId:selectedTestCategory}" [ngClass]="{'borderRed':architectureSubCategory.isEmptyArchitectureSubCategory && architectureSubCategory.isSubmitted}" (blur)="validateArchitectureSubCategoryForm()">
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{architectureSubCategory.testCategoryLbl}}<span class="requiredField">*</span>
                    </label>
                    <kendo-dropdownlist class="kendoInput" formControlName="testCategory" [data]="testCategoryData"
                                        textField="testCategoryDescription" valueField="testCategoryId" [ngClass]="{'borderRed':architectureSubCategory.isEmptyTestCategory && architectureSubCategory.isSubmitted}" [ngModel]="{testCategoryDescription:selectedTestCategory,testCategoryId:selectedTestCategory}" (blur)="validateArchitectureSubCategoryForm()">
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{architectureSubCategory.testSubCategoryLbl}}<span class="requiredField">*</span>
                    </label>
                    <input type="text" kendoTextBox formControlName="testSubCategory" class="kendoInput" [ngClass]="{'borderRed':architectureSubCategory.isEmptyTestSubCategory && architectureSubCategory.isSubmitted}" (blur)="validateArchitectureSubCategoryForm()" />
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{architectureSubCategory.isArchitectureSubCategoryActiveLbl}}
                    </label>
                    <kendo-switch formControlName="isArchitectureSubCategoryActive" [onLabel]="'Yes'" [offLabel]="'No'"
                                  class="activeSwitchCls">
                    </kendo-switch>
                  </div>
                </div>

              </div>

              <div class="dialog-btn-section">
                <div class="row">
                  <div class="col-sm-12 float-left">
                    <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 btn-align-center">
                    <div class="btn-group" role="group">
                      <button kendoButton [disabled]="architectureSubCategorySaveInProcess" class=" m-3 btn k-button dialogBtnSize"
                              (click)="toggleArchitectureSubCategoryDialog()">
                        Close
                      </button> &nbsp;&nbsp;
                      <button kendoButton [disabled]="architectureSubCategorySaveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                              (click)="saveTestSubCategory()">
                        Save<kendo-loader *ngIf="architectureSubCategorySaveInProcess" style="color:blue"></kendo-loader>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </kendo-dialog>
        </section>

        <section class="dialogSection">
          <kendo-dialog title="Add Test Category" *ngIf="testCategoryDialog.opened" (close)="toggleTestCategoryDialog()">
            <form [formGroup]="testCategoryForm">
              <div class="row">
                <input type="hidden" formControlName="testCategoryId" />
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="lblCls">
                      {{testCategory.architectureSubCategoryLbl}}<span class="requiredField">*</span>
                    </label>
                    <kendo-dropdownlist class="kendoInput" formControlName="subCategoryDescription" [data]="architectureSubCategoryData"
                                        textField="subCategoryDescription" valueField="subCategoryId" [ngModel]="{subCategoryDescription:selectedSubCategory,subCategoryId:selectedSubCategory}" [ngClass]="{'borderRed':testCategory.isEmptyArchitectureSubCategory && testCategory.isSubmitted}" (blur)="validateTestCategoryForm()">
                    </kendo-dropdownlist>
                  </div>

                  <div class="form-group">
                    <label class="lblCls">
                      {{testCategory.testCategory}}<span class="requiredField">*</span>
                    </label>
                    <input type="text" kendoTextBox formControlName="testCategoryDescription" class="kendoInput" [ngClass]="{'borderRed':testCategory.isEmptyTestCategory && testCategory.isSubmitted}" (blur)="validateTestCategoryForm()" />
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{testCategory.isTestCategoryActiveLbl}}
                    </label>
                    <kendo-switch formControlName="isTestCategoryActive" [onLabel]="'Yes'" [offLabel]="'No'"
                                  class="activeSwitchCls">
                    </kendo-switch>
                  </div>
                </div>

              </div>

              <div class="dialog-btn-section">
                <div class="row">
                  <div class="col-sm-12 float-left">
                    <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 btn-align-center">
                    <div class="btn-group" role="group">
                      <button kendoButton [disabled]="testCategorySaveInProcess" class=" m-3 btn k-button dialogBtnSize"
                              (click)="toggleTestCategoryDialog()">
                        Close
                      </button> &nbsp;&nbsp;
                      <button kendoButton [disabled]="testCategorySaveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                              (click)="saveTestCategory()">
                        Save<kendo-loader *ngIf="testCategorySaveInProcess" style="color:blue"></kendo-loader>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </kendo-dialog>
        </section>
        <section class="dialogSection">
          <kendo-dialog title="Test Report" *ngIf="testReportDialog.opened" (close)="toggleTestReportDialog()">
            <form [formGroup]="testReportForm" style="max-height: 450px">
              <div class="row">
                <input type="hidden" formControlName="testReportId" />
                <div class="col-sm-12">
                  <div class="form-group">
                    <label class="lblCls">
                      {{testReportLbl.architectureSubCategory}}<span class="requiredField">*</span>
                    </label>
                    <kendo-dropdownlist class="kendoInput" formControlName="architectureSubCategory"
                                        [ngModel]="{subCategoryDescription:selectedSubCategory,subCategoryId:selectedSubCategoryId}" [data]="architectureSubCategoryData"
                                        textField="subCategoryDescription" valueField="subCategoryId" (selectionChange)="architectureSubCategoryChange($event)"
                                        [ngClass]="{'borderRed':testReportLbl.isEmptyArchitectureSubCategory && testReportLbl.isSubmitted}" (blur)="validateTestReportTypeForm()">
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{testReportLbl.testCategory}}<span class="requiredField">*</span>
                    </label>
                    <kendo-dropdownlist class="kendoInput" formControlName="testCategory" [data]="testCategoryData"
                                        textField="testCategoryDescription" valueField="testCategoryId"
                                        [ngModel]="{testCategoryDescription:selectedTestCategory,testCategoryId:selectedTestCategoryId}"
                                        (selectionChange)="testCategoryChange($event)"
                                        [ngClass]="{'borderRed':testReportLbl.isEmptyTestCategory && testReportLbl.isSubmitted}" (blur)="validateTestReportTypeForm()">
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{testReportLbl.testSubCategory}}<span class="requiredField">*</span>
                    </label>
                    <kendo-dropdownlist class="kendoInput" formControlName="testSubCategory" [data]="testSubCategoryData"
                                        textField="testSubCategoryDescription" valueField="testSubCategoryId"
                                        [ngModel]="{testSubCategoryDescription:selectedTestSubCategory,testSubCategoryId:selectedTestSubCategoryId}"
                                        [ngClass]="{'borderRed':testReportLbl.isEmptyTestSubCategory && testReportLbl.isSubmitted}" (blur)="validateTestReportTypeForm()">
                    </kendo-dropdownlist>


                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{testReportLbl.testType}}<span class="requiredField">*</span>
                    </label>
                    <input type="text" kendoTextBox formControlName="testType" class="kendoInput"
                           [ngClass]="{'borderRed':testReportLbl.isEmptyTestType && testReportLbl.isSubmitted}" (blur)="validateTestReportTypeForm()" />
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{testReportLbl.testDescription}}<span class="requiredField">*</span>
                    </label>
                    <input type="text" kendoTextBox formControlName="testDescription" class="kendoInput"
                           [ngClass]="{'borderRed':testReportLbl.isEmptytestDescription && testReportLbl.isSubmitted}" (blur)="validateTestReportTypeForm()" />
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{testReportLbl.reportNumber}}<span class="requiredField">*</span>
                    </label>
                    <input type="text" kendoTextBox formControlName="reportNumber" class="kendoInput"
                           [ngClass]="{'borderRed':testReportLbl.isEmptyReportNumber && testReportLbl.isSubmitted}" (blur)="validateTestReportTypeForm()" />
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{testReportLbl.ecNumber}}<span class="requiredField">*</span>
                    </label>
                    <input type="text" kendoTextBox formControlName="ecNumber" class="kendoInput"
                           [ngClass]="{'borderRed':testReportLbl.isEmptyECNumber && testReportLbl.isSubmitted}" (blur)="validateTestReportTypeForm()" />
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{testReportLbl.ecVersion}}<span class="requiredField">*</span>
                    </label>
                    <input type="text" kendoTextBox formControlName="ecVersion" class="kendoInput"
                           [ngClass]="{'borderRed':testReportLbl.isEmptyECVersion && testReportLbl.isSubmitted}" (blur)="validateTestReportTypeForm()" />
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{testReportLbl.uploadUrl}}
                      <!--<span class="requiredField">*</span>-->
                    </label>
                    <!--<input type="file" class="k-button btn kendoInput" formControlName="testReportfileUpload" name="fileupload"
                    (change)="handleFileInputTestReport($event.target.files)" />-->
                    <div class="kendoInput">
                      <app-upload [multiple]="false" (fileSelect)="testReportImageSelected($event)" [uploadFolderPath]="'TempDocs'"
                                  (uploadSuccess)="testReportUploadSuccess($event)" [fileRestrictions]="fileRestrictions"></app-upload>
                    </div>
                    <label class="lblCls">
                      {{fileTestReportPath}}
                    </label>
                  </div>
                  <div class="form-group">
                    <label class="lblCls">
                      {{testReportLbl.isActive}}
                    </label>
                    <kendo-switch formControlName="isTestReportTypeActive" [onLabel]="'Yes'" [offLabel]="'No'"
                                  class="activeSwitchCls">
                    </kendo-switch>
                  </div>
                </div>

              </div>

              <div class="dialog-btn-section">
                <div class="row">
                  <div class="col-sm-12 float-left">
                    <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 btn-align-center">
                    <div class="btn-group" role="group">
                      <button kendoButton [disabled]="testReportsaveInProcess" class=" m-3 btn k-button dialogBtnSize"
                              (click)="toggleTestReportDialog()">
                        Close
                      </button> &nbsp;&nbsp;
                      <button kendoButton [disabled]="testReportsaveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                              (click)="saveTestReport()">
                        Save<kendo-loader *ngIf="testReportsaveInProcess" style="color:blue"></kendo-loader>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </kendo-dialog>
        </section>
      </section>
    </ng-template>
  </kendo-tabstrip-tab>

</kendo-tabstrip>
<kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    {{gridDelete.label.deleteConfirmLbl?gridDelete.label.deleteConfirmLbl:gridDelete.label.deleteConfirmLbl}}
    {{type}}
    <b *ngIf="type=='SubCategory'"> : {{ gridItemToRemove.subCategoryDescription }}</b>
    <b *ngIf="type=='TestReport'"> : {{ gridItemToRemove.testReportDescription }}</b>
    ?

  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
